module.exports = __webpack_public_path__ + "static/img/home_yali_bg.15ace72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_yali_bg.png
// module id = znAk
// module chunks = 0